import { render } from "./Diagnosis2.vue?vue&type=template&id=421ffcdf"
import script from "./Diagnosis2.vue?vue&type=script&lang=js"
export * from "./Diagnosis2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/Diagnosis2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "421ffcdf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('421ffcdf', __exports__)) {
    api.reload('421ffcdf', __exports__)
  }
  
  module.hot.accept("./Diagnosis2.vue?vue&type=template&id=421ffcdf", () => {
    api.rerender('421ffcdf', render)
  })

}


export default __exports__